import React from "react";
import fondo1 from "../../../assets/img/promocionBlustay/fondo1.png";
import logo from "../../../assets/img/promocionBlustay/logo.png";
const videoLanding = require("../../../assets/img/promocionBlustay/video-landing.mp4");

const VideoInicio = () => {
    return (
        <div className="relative w-full flex flex-col items-center">
            {/* Fondo que ocupa toda la altura del contenedor */}
            <img
                src={fondo1}
                alt="fondo1"
                className="absolute inset-0 w-full h-full 2xl:h-[1000px] xl:h-[900px] object-cover -z-10"
            />

            {/* Contenido */}
            <div className="w-full flex flex-col justify-start items-center text-white mt-8">
                <img src={logo} alt="logo" className=" md:h-12 h-8" />

                <div
                    className="text-2xl md:text-4xl font-bold text-center mx-auto mt-3 uppercase"
                    style={{ textShadow: "2px 2px 8px rgba(0,0,0,0.8)" }}
                >
                    La mejor solución
                </div>

                <div
                    className="text-lg md:text-3xl font-bold mb-2 text-center mx-auto uppercase"
                    style={{ textShadow: "2px 2px 8px rgba(0,0,0,0.8)" }}
                >
                    en gestión de propiedades
                </div>

                {/* Video sobresaliendo un poco */}
                <div className="w-3/4 2xl:w-[500px] xl:w-[450px] mx-auto mt-3 relative shadow-[6px_8px_12px_0px_rgba(0,_0,_0,_0.8)] -mb-[10%]">
                    <video
                        src={videoLanding}
                        autoPlay
                        loop
                        controls
                        playsInline
                        className="w-full 2xl:w-[500px] xl:w-[450px] rounded-lg shadow-lg h-auto object-cover mx-auto"
                    />
                </div>
            </div>
        </div>
    );
};
export default VideoInicio;
